import auth from '../../../services/auth'
import account from '../../../services/account'
import * as _ from 'lodash'
import messageDialog from '../../../components/message-dialog.vue'
import {cpfCnpj, phone} from '../../../filters/string'

export default {
  data() {
    return {
      user: auth._currentUser,
      telObj: undefined,
      celObj: undefined,
      allowSMS: false,
      notificationLimit: undefined,
      loadingUser: Promise.resolve(true),
      loading: undefined,
      semTel: undefined,
      isCampoDesabilitado: undefined,
      isTelDisable: false,
      is2faValid: undefined
    }
  },
  computed: {
    cel: {
      get() {
          return phone(this.user.dddCellphone + this.user.nroCellphone);
        // return "";
      },
      set(newValue) {
        this.$nextTick(()=>{
          //para o cursor continuar no final do input
          $('#telefone').val($('#telefone').val());
        });
        let t = newValue.replace(/[^0-9]/g, '');
        if(t.length > 11){
          this.$validator.validateAll();
          return false;
        }
        this.user.dddCellphone = t.substring(0, 2);
        this.user.nroCellphone = t.substring(2, 11);
        }
    },
    tel: {
      get() {
          return phone(this.user.dddPhone + this.user.nroPhone);
        // return "";
      },
      set(newValue) {
        this.$nextTick(()=>{
          //para o cursor continuar no final do input
          $('#telefone').val($('#telefone').val());
        });
        let t = newValue.replace(/[^0-9]/g, '');
        if(t.length > 11){
          this.$validator.validateAll();
          return false;
        }
        this.user.dddPhone = t.substring(0, 2);
        this.user.nroPhone = t.substring(2, 11);
        }
    },
  },
  created() {
    //this.telObj = this.getTelType("COMERCIAL");
    //this.celObj = this.getTelType("CELULAR");
    //this.user.taxIdNumber = cpfCnpj(this.user.taxIdNumber);
  },

  mounted() {

    if (this.user.flag2FA == "N") {
      this.is2faValid = false;
    } else {
      this.is2faValid = true;
    }

    if (this.is2faValid) {
      this.isCampoDesabilitado = true;
    } else {
      this.isCampoDesabilitado = false;
     }
    account.getNotification().then(res => {
      this.notificationLimit = _.find(res, (obj) => {
        return obj.userNotificationId == 7
      });
      if(this.notificationLimit){
        this.allowSMS = this.notificationLimit.sms;
      } else {
        this.allowSMS = false;
      }

      // if(!this.user.nroPhone){
      //   //se não tiver telefone quando entra deixa habilitado para incluir
      //   this.semTel = true;
      // }
    });
  },

  methods: {
    correctCursor(a){
      if(!window.document.mobile)
        return;

      setTimeout(() => {
        $(a.target).val($(a.target).val());
      }, 80);
    },

    // getTelType(type) {

    //   let tels = _.filter(this.user.telephones.telephone, o => o.type == type);

    //   if (tels && tels.length > 0)
    //     return  _.orderBy(tels, ['ddd'],['desc'])[0];

    //   var t = { 'ddd': '', 'numberPhone': '', 'type': type }
    //   this.user.telephones.telephone.push(t);

    //   return t;
    // },
    getTelFormated(obj) {
      return phone(obj.ddd + obj.numberPhone)
    },
    setTelFormated(value, obj) {
      let t = value.replace(/[^0-9]/g, '');
      if(t.length > 11){
        this.$validator.validateAll();
        return false;
      }
      obj.ddd = t.substring(0, 2);
      obj.numberPhone = t.substring(2, 11);
    },
    updateUser() {
      return this.$validator.validateAll()
        .then(success => {
          let aux = _.cloneDeep(this.user);
          /*para não enviar esses campos na request*/
          delete aux.accountAuthentication;
          delete aux.company;
          delete aux.person;
          return this.loading =  account.updateUser(aux)
            .then(resp => {
              auth.updateLocalStorage();
            }).then(res => {
              this.notificationLimit.sms = this.allowSMS;
              let req = {
                notifications: {
                  notification: [this.notificationLimit]
                }
              };

              return account.upSertNotification(req);
            })
            .catch(err =>
              messageDialog.show({ title: 'Erro', message: err.data.status.message, headerClass: 'modal-danger' })
            );
        });
    },

    changeEmail() {
      let taxIdNumber = this.user.taxIdNumber;
      this.loadingUser = account.requestChangeUserEmail(taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase())
      .then(success => {
        this.$router.push({ name: 'user-contacts-change', params: { type: 'UPDATE_USER_EMAIL' } });
      }).catch(err =>
        messageDialog.show({ title: 'Erro', message: err.data.status.message, headerClass: 'modal-danger' })
      );
    },

    changePhone() {
      let taxIdNumber = this.user.taxIdNumber;
      this.loadingUser = account.requestChangeUserPhone(taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase())
      .then(success => {
        this.$router.push({ name: 'user-contacts-change', params: { type: 'UPDATE_USER_PHONE' } });
      }).catch(err =>
        messageDialog.show({ title: 'Erro', message: err.data.status.message, headerClass: 'modal-danger' })
      );
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/account/profile/user.js